// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1qCB4pp_F0YfqmM3OomQj","header":"_2HN1oBiDYsreLqiAJQKETq","pill":"acEXR4hmgqZLU6ojgHb1U","footer":"_1AQBc1yZt6Jk9LoGS_95RZ"};